module.exports = __webpack_public_path__ + "123fe9e4414d46bf173358459591863a.svg";